import { render, staticRenderFns } from "./EditFeedProductPage.vue?vue&type=template&id=194e97e0&"
import script from "./EditFeedProductPage.vue?vue&type=script&lang=ts&"
export * from "./EditFeedProductPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports